import { ioExtend, ioGuid, QueryParams } from '@framework';

export class ResourceModel {
    ProjectID : string = null;
    InstanceID : string = null;
    Resource : string = null;
    LanguageCode : string = null;
    Translation : string = null;

    constructor(_Instance?: {}) {
        ioExtend(this, _Instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }
}